if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.onDocumentInteraction = this.onDocumentInteraction.bind(this);
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        document.addEventListener('click', this.onDocumentInteraction);
        document.addEventListener('touchstart', this.onDocumentInteraction, { passive: true });

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentInteraction);
        document.removeEventListener('touchstart', this.onDocumentInteraction);
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const selectedLocale = event.currentTarget.dataset.value;
        this.elements.input.value = selectedLocale;
        if (this.elements.input.name === 'locale_code') {
          try {
            window.localStorage.setItem('rw_language_preference', selectedLocale);
            window.sessionStorage.removeItem('rw_default_ar_attempted');
          } catch (error) {
            // Storage can be unavailable in restricted browsing contexts.
          }
        }
        if (form) form.submit();
      }

      openSelector() {
        const isMobileMenuLanguage = this.closest('.language_currency_mobile');
        if (isMobileMenuLanguage && this.elements.button.getAttribute('aria-expanded') === 'true') return;
        this.elements.button.focus();
        if (isMobileMenuLanguage) {
          this.elements.panel.removeAttribute('hidden');
          this.elements.button.setAttribute('aria-expanded', 'true');
          return;
        }
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        // Keep the mobile drawer language choices open while focus moves inside
        // the drawer. They are closed by an outside click or after selection.
        if (this.closest('.language_currency_mobile')) return;
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }

      onDocumentInteraction(event) {
        if (this.elements.button.getAttribute('aria-expanded') === 'false') return;
        if (this.contains(event.target)) return;
        this.hidePanel();
      }
    }
  );
}
